import React from 'react';
import classNames from 'classnames';
import Survey from '../components/c-survey';

export default function SurveyBlock(props) {
  const classes = classNames({
    'c-survey-content__item': true,
    'c-intro-content__item': props.PropertyName === 'IntroContent',
  });
  const containerClasses = classNames({
    'c-survey__container': true,
    'c-intro-content__item__container': props.PropertyName === 'IntroContent',
  });

  return (
    <div className={classes}>
      <div className={containerClasses}>
        <Survey {...props} resultMeterColors={['#F01E00']} />
      </div>
    </div>
  );
}
